import React, { Fragment, useState, useEffect, useRef } from "react";
import Navbar from "../../Navbar";
import Footer from "../../Footer";
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import SignatureCanvas from 'react-signature-canvas';
const { config } = require('../../api/api');

function LifeTermPlanPolicyStatus() {

  const base_url = config.baseURL;
  const redirect_url = config.redirectURL;

    const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';

    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState();
    const [policy, setPolicyValue] = useState('');
    const [modalMessage, setModalMessage] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isErrorModal, setIsErrorModal] = useState(false);
    const [Referanceid, setReferanceid] = useState('');


    const [dhofarData, setDhofarData] = useState(false);
  const [age, setAge] = useState(null);
  useEffect(() => {


    const storedDhofarString = Cookies.get('personalData'); //sessionStorage.getItem('userData')
    debugger
    if (storedDhofarString !== undefined) {
      const storedDhofar = JSON.parse(storedDhofarString);
      setDhofarData(storedDhofar);
    }
    else {
      alert("token expired");
      window.location.href='/';
    }

  }, []);



   useEffect(() => {
    const storedUserString = Cookies.get("userData"); 
    if (storedUserString !== undefined && storedUserString !== "undefined") {
      const storedUser = JSON.parse(storedUserString);
      setUserData(storedUser);
    }
  }, []);


  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden'; 
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto'; 
    };
  }, [isModalOpen]);


  const [vendorKey, setVendorkey] = useState('');

  useEffect(() => {

    const postvData = { organization_name: "Superjet" };
    debugger

    if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {


      fetch( base_url + '/create_organization', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postvData),
      })
        .then(response => response.json())
        .then(data => {
          setVendorkey(data.result[0].vendor_key);
        })
        .catch(error => {
          console.error('Error posting data:', error);
        });


    }
  }, [vendorKey]);


  const [payment_link , setPaymentValue] = useState('');



  const handlePolicy = async ( ) => {

    debugger
    
        const bacsicinfojson = sessionStorage.getItem('personalaccidentbasicinfo');
    const basicinfo = JSON.parse(bacsicinfojson);
    
    const basicPremiumjson = sessionStorage.getItem('personalaccidentpremiumcover');
    const basicPremium = JSON.parse(basicPremiumjson);
    
    
    const addbenefityjson = sessionStorage.getItem('personalaccidentbeneficiaries');
    const addbenefity = JSON.parse(addbenefityjson);
    
    const personalinfojson = sessionStorage.getItem('persionalaccidentinformationpage');
    const personalinfo = JSON.parse(personalinfojson);
    
    const personalquestionjson = sessionStorage.getItem('personalquestionvalue');
    const personalqus = JSON.parse(personalquestionjson);
    
    const personalamountjson = sessionStorage.getItem('personalaccdientamount');
    const personalamount = JSON.parse(personalamountjson)
    
    function formatDOB(dob) {
      const date = new Date(dob);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }
      
    
    
        debugger
    
        var quotation_data1 =
        {
          "token": dhofarData,
          "cover_type": "Term Plan",
          "application_type": "self",
          "plan": "Term Plan",
          "nationality": personalinfo.nationality,
          "civil_id": personalinfo.civilid,
          "sum_assured": basicPremium.premium_valu,
          "personalInformation": {
            "fullName": personalinfo.fullName,
            "email": personalinfo.email,
            "mobileNumber": personalinfo.mobilenumber,
            "dob": formatDOB(basicinfo.dob),
            "resident_location": personalinfo.Residential_Location,
            "gender": basicinfo.basicinfo_gender_detail.toLowerCase(),
            "is_married": basicinfo.basicinfo_marital_status_detail.toLowerCase() === "single" ? 'no' : 'yes',
            "height": personalinfo.height,
            "weight": personalinfo.weight,
            "occupation": personalinfo.occupation,
            "occupation_code": personalinfo.occupation_code,
            "passport": personalinfo.passportnumber,
            "vat_in": personalinfo.vat_in,
            "id_expiry_date": formatDOB(personalinfo.id_expiry_date),
          },
          "beneficiaries": addbenefity.beneficiaries,
          "amount": personalamount,
           ...Object.fromEntries(Object.entries(personalqus).filter(([k]) => k !== 'signature')),
          // "on_medication": personalqus.on_medication,
          // "have_travelled": personalqus.have_travelled,
          // "in_good_health": personalqus.in_good_health,
          // "is_armed_member": personalqus.is_armed_member,
          "signature": personalqus.signature
        };
        var policy_url = '';
        if(userData && userData.type=="staff"){
           policy_url =base_url + '/life_term_plan_add_policy_by_staff'
          quotation_data1["agent_staff_token"] = userData.access_token;
        }
        else if (userData != null && userData != undefined && userData.agency_name != undefined) {
          policy_url =base_url + '/life_term_plan_add_policy_byagent'
          quotation_data1["agent_token"] = userData.access_token;
        }
        else if(userData != null && userData != undefined && userData.traveller_id != undefined && userData.first_name != undefined){
        policy_url =base_url + '/life_term_plan_add_policy_byuser'
        quotation_data1["user_token"] = userData.access_token;
    }
        else{
          policy_url =base_url + '/life_term_plan_add_policy'
        }
    
        
        if (vendorKey !== '') {
          // const fetchPolicy = async () => {
          try {
            
            const Personalpolicy = await fetch( policy_url, {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${vendorKey}`,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(quotation_data1),
            });
    
            if (!Personalpolicy.ok) {
              throw new Error('Network response was not ok');
            }
            debugger
    
            const data = await Personalpolicy.json();
    
            if (data?.result?.policy_number != null && data?.result?.policy_number != undefined) {
              // setPolicyValue(data?.result?.policy_number);
              await handleQotation(data?.result?.policy_number);
              setLoading(false);  
    
          } else {
            debugger
            if (data?.result?.errors?.message?.[0] != undefined) {
              setModalMessage(data.result.errors.message[0].replace(/<br>/g, '\n'));
              setIsErrorModal(true);
              setIsModalOpen(true);
              setLoading(false);
            } else if (data?.result?.decision_reasons != undefined && data?.result?.decision_reasons[0] != undefined) {
              var referance_id = data?.result?.referal_quote_id;
              setModalMessage(data?.result?.decision_reasons[0]);
              setReferanceid(referance_id);
              setIsModalOpen(true);
              setLoading(false);
            }
          }
    
          } catch (error) {
            console.error('Error fetching occupations:', error);
          }
          // };
    
    
        }
      };

  debugger



  const handleQotation = async (policy_no) => {

    
  
      debugger
  
      var quotation_data =
      {
        "token": dhofarData,
        "policy_no":policy_no,
        "redirect_url": redirect_url + '/termplan-downloadpolicy?policyno='+ policy_no
      };
      debugger
      if (vendorKey !== '') {
        // const fetchPolicy = async () => {
        try {
  
  
          const Policyresponce = await fetch( base_url + '/create_term_plan_payment_link', {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${vendorKey}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(quotation_data),
          });
  
          if (!Policyresponce.ok) {
            throw new Error('Network response was not ok');
          }
          debugger
  
          const data = await Policyresponce.json();
  
        setPaymentValue(data.result.data.payment_url);
        window.location.href = data.result.data.payment_url;
        //   await handlePolicy(data.result.data.amount)
        } catch (error) {
          console.error('Error fetching occupations:', error);
        }
        // };
  
  
      }
    };
    const NumberFormatter = ({ value }) => {
      // Ensure value is a number and format to 3 decimal places
      const formattedValue = `${Number(value).toFixed(3)} OMR`;
    debugger
      return formattedValue ;
    };

    const handleSubmit = async (event) => {
      setLoading(true);
debugger
      await handlePolicy();  
    
      };

      const handlecancel = async (event) => {

        window.location.href = './term-plan'
      };

      const handlepopupclose = async () =>{
        setIsModalOpen(false);
        setIsErrorModal(false);
        if (!isErrorModal) window.location.href = '/life-accident-insurance';
      }

      function formatDOB(dob) {
        const date = new Date(dob);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }

      debugger

      const sumassuredjson = sessionStorage.getItem("personalaccidentpremiumcover");
      const sumaasured = JSON.parse(sumassuredjson);

      const personalinfojson = sessionStorage.getItem('persionalaccidentinformationpage');
      const personalinfo = JSON.parse(personalinfojson);

      const amountjson = sessionStorage.getItem('personalaccdientamount');
      const amount = JSON.parse(amountjson);



  return (


    <Fragment>

      <div className="header_section1">

        <Navbar />


        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{(lnstr === 'en') ? 'Term Plan Insurance Policy' : 'بوليصة التأمين ضد الحوادث الشخصية\n'}</h3>
          </div>
        </div>


      </div>


      <div className="features_section">
        <div className="container">

          <div className="row">

            <Col md={3}></Col>
            {/* style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} */}

            <Col md={6} className="myforms my-5">

            <h1 style={{textAlign:"center"}}><b>{(lnstr === 'en') ? 'SUMMARY' : 'ملخص\n'}</b></h1>



            {/* <h2 style={{textAlign:'left'}}>{(lnstr === 'en') ? 'Plan Details':'تفاصيل الخطة'}</h2> */}
            <div className="d-flex justify-content-between my-3 colmds-4 card m-0">
              <div className="d-flex justify-content-between my-3">
                <div>
                <p>{(lnstr === 'en') ? 'Plan Type' :'نوع الخطة'}</p>
                <h6><strong>{t("Term Plan")}</strong></h6>
                </div>
                <div>
              <p>{(lnstr === 'en') ? 'Sum Assured':'المبلغ المؤمن'}</p>
              <h6><strong>{sumaasured !=null ? sumaasured ?.premium_valu :''}</strong></h6>
              </div>
              
              </div>
              
            </div>

            


            <br />
            <h3>{(lnstr === 'en') ? 'Personal Details':'التفاصيل الشخصية'}</h3>

            <div>
            <table className="table table-bordered table-condenced" style={{ textAlign: 'left' }}>

  <tbody>

      <tr><td style={{ width: '50%' }}>
    {t("First Name")}
          </td><td><b>{personalinfo != null ? personalinfo ?.fullName : ''}</b></td></tr>

      <tr><td>{t("Email")}	
          </td><td><b>{personalinfo != null ? personalinfo ?.email : ''}</b></td></tr>
        
      
          <tr><td>{t("Civil ID")}
      
      </td><td><b>{personalinfo != null ? personalinfo?.civilid : ''}</b>
      </td></tr>


      <tr><td>{t("Mobile")}
  </td><td><b>{personalinfo !=null ? personalinfo ?.mobilenumber : ''}</b></td></tr>

      <tr><td>{t("Expiry Date of Civil ID / Passport")}
          </td><td><b>{personalinfo != null ? formatDOB (personalinfo?.expiry_date) : ''}</b></td></tr>

      <tr><td>{t("Passport")}
  </td><td><b>{personalinfo != null ? personalinfo?.passportnumber : ''}</b></td></tr>

  <tr><td>{t("Nationality")}
  </td><td><b>{personalinfo != null ? personalinfo?.nationality: ''}</b></td></tr>
  </tbody>

  </table>
            </div>
            {/* <div className="row">



            <table className="table table-bordered table-condenced">

    <tbody>

    <tr><td>First Name</td><td><b>{personalinfo != null ? personalinfo ?.fullName : ''}</b></td>
    <td>Email</td><td><b>{personalinfo != null ? personalinfo ?.email : ''}</b></td></tr>

    <tr><td>Civil ID</td><td><b>{personalinfo != null ? personalinfo?.civilid : ''}</b></td>
    <td>Mobile</td><td><b>{personalinfo !=null ? personalinfo ?.mobilenumber : ''}</b></td></tr>

    <tr><td>Passport</td><td><b>{personalinfo != null ? personalinfo?.passportnumber : ''}</b></td>
    <td>Expiry Date of Civil ID / Passport</td><td><b>{personalinfo != null ? formatDOB (personalinfo?.expiry_date) : ''}</b></td></tr>

    <tr><td>Gender</td><td><b>gender</b></td>
    <td>Marital Status</td><td><b>marital_status_value</b></td></tr>

    <tr><td>Residential Location</td><td><b>{personalinfo != null ? personalinfo?.Residential_Location: ''}</b></td>
    <td>Nationality</td><td><b>{personalinfo != null ? personalinfo?.nationality: ''}</b></td></tr>

    </tbody>

    </table>
                            
                            </div> */}
                            <br/>



                            <h3>{(lnstr === 'en') ? 'Premium Details':'تفاصيل متميزة'}</h3>
            <div>
            <table className="table table-bordered table-condenced" style={{ textAlign: 'left' }}>

  <tbody>

      <tr><td style={{ width: '50%' }}>
      {t("Basic premium")}
          </td><td><b>{amount != null ? <NumberFormatter value={amount?.base_price} /> : ''}</b></td></tr>

      <tr><td>{t("Policy")} {t("Fee")}	
          </td><td><b>{amount != null ? <NumberFormatter value={amount?.policy_fee} /> : ''}</b></td></tr>
        
      
          <tr><td>{t("Government")} {t("Fee")}
      
      </td><td><b>{amount != null ? <NumberFormatter value={amount?.government_fee} />: ''}</b>
      </td></tr>


      <tr><td>{t("Emergency")} {t("Fund")} {t("Fee")}
  </td><td><b>{amount != null ? <NumberFormatter value={amount?.emergency_fund_fee} />: ''}</b></td></tr>

      <tr><td>{t("VAT")}
          </td><td><b>{amount != null ?<NumberFormatter value={amount?.vat} />  : ''}</b></td></tr>

      <tr><td>{t("Total")} {t("Premium")}
  </td><td><b>{amount != null ?<NumberFormatter value={amount?.total} />  : ''}</b></td></tr>
  </tbody>

  </table>
            </div>


            {/* <p style={{textAlign:'center'}}><strong>{policy_no}</strong></p> */}

            <div className="d-flex row  my-3">

            <button className="btn btn-primary" style={{ padding: '10px 30px' , marginLeft:'15px',  marginRight : '10px'}}   onClick={handlecancel} >{t("Edit")}</button>

            <button className="btn btn-primary"  onClick={handleSubmit} >{t("Proceed to Payment")}</button>

            </div>

            


            </Col>

            <Col md={3}></Col>

          </div>


          {isModalOpen && (
                <div className="modal" style={{ display: 'block', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
                    <div className="modal-content" style={{ background: '#fff', margin: '10% auto', padding: '20px', width: '50%', borderRadius: '8px', position: 'relative' }}>
                        <span className="close" onClick={() => handlepopupclose()}>&times;</span>
                        {isErrorModal ? (
                          <div style={{ textAlign: 'center', padding: '10px' }}>
                            <div style={{ fontSize: '48px', color: 'red' }}>&#10006;</div>
                            <h3 style={{ color: 'red' }}>{lnstr === 'en' ? 'Policy Error' : 'خطأ في السياسة'}</h3>
                            {modalMessage && <p style={{ color: 'red', whiteSpace: 'pre-line' }}>{modalMessage}</p>}
                            <button className="btn btn-danger mt-2" onClick={() => handlepopupclose()}>{lnstr === 'en' ? 'Close' : 'إغلاق'}</button>
                          </div>
                        ) : (
                          <div>
                            <div>
                              <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" style={{ width: '52px', height: '52px' }}><circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"></circle><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"></path></svg>
                            </div>
                            <div>{lnstr === 'en' ? <h3>Thank you for contacting</h3> : <h3>شكرا لتواصلك</h3>}</div>
                            <div>{lnstr === 'en' ? <p>We have received your request for</p> : <p>لقد تلقينا طلبك</p>}</div>
                            {Referanceid && <div>{Referanceid}</div>}
                            {modalMessage && <p style={{ color: 'red', whiteSpace: 'pre-line' }}>{modalMessage}</p>}
                            <div>{lnstr === 'en' ? <p>Please call us @ + 968 7707 4345 for further assistance.</p> : <p>برجاء الاتصال بنا على الرقم +968 7707 4345 لمزيد من المساعدة.</p>}</div>
                          </div>
                        )}
                    </div>
                </div>
            )}


        </div>
      </div>

      <Footer />

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

    </Fragment>



    
  );
}

export default LifeTermPlanPolicyStatus;